$(window).ready(function() {
  reserve = JSON.parse(localStorage.getItem('reserve'));
  if (reserve == null) {
    $('.p-my').html('<div class="p-my_content"><h2 class="c-title">マイページ</h2><p class="p-my_content_text">ご予約情報はありません。</p></div><div class="p-my_link"><a class="c-btn" href="/reservation">ご予約はコチラから</a></div>');
  } else {
    items = (reserve['items']);
    carry_type = (reserve['carry_type']);
    $('#reserve_id').val(reserve['id']);
    $('#name').text(reserve['name'] + ' 様');
    $('#tel').text(reserve['tel']);
    $('#store_name').text(reserve['store_name']);
    $('#requested_at').text(reserve['requested_at']);
    $('#price').text('￥' + reserve['price']);
    $('.p-my_content_clear').append('<p id="clear">全ての予約をキャンセル</p>');
    $.each(items, function (index, value) {
      $('.js-items').append('<div class="p-my_content_items_item js-items-item-' + (index + 1) + '"></div>');
      $('.js-items-item-' + (index + 1)).append('<p class="p-my_content_items_item_type"><span>' + (index + 1) + '</span>' + carry_type + '</p>');
      $('.js-items-item-' + (index + 1)).append('<p class="p-my_content_items_item_name">' + value.name + '</p>');
      if(value.remark != '') {
        $('.js-items-item-' + (index + 1)).append('<div class="p-my_content_items_item_remark"><p class="p-my_content_items_item_remark_label">その他持ち込み商品</p><p class="p-my_content_items_item_remark_text">' + value.remark.replace(/\n/g, '<br>') + '</p></div>');
      }
      $('.js-items-item-' + (index + 1)).append('<p class="p-my_content_items_item_course">' + value.course_type + '</p>');
      let requested_day = new Date(reserve['requested_at'].replace( /(年|月|日)/g, '/' ));
      let requested_tomorrow = requested_day.setDate(requested_day.getDate() + 1)
      let _today = new Date();
      let today = new Date(_today.getFullYear(), _today.getMonth(), _today.getDate(), 0, 0, 0);
      if(requested_tomorrow > today) {
        $('.js-items-item-' + (index + 1)).append(`<p class="p-my_content_items_item_cancel item-cancel" data-id="${value.id}">予約をキャンセル</p>`);
      }
    });
  }

  $('#clear').on('click', function() {
    if(!confirm('全ての商品をキャンセルしてもよろしいですか？')){
      return false;
    } else {
      let id = $('#reserve_id').val();
      $.ajax({
        url: '/reservations/destroy',
        type: 'POST',
        data: { id: id }
      }).done(function() {
        localStorage.removeItem('reserve');
        window.location.href = '/my';
      });
    }
  });

  $('.item-cancel').on('click', function() {
    if(!confirm('この商品をキャンセルしてもよろしいですか？')) {
      return false;
    } else {
      let id = $(this).data('id');
      let index = $('.item-cancel').index(this);
      let reserve = JSON.parse(localStorage.getItem('reserve'));
      let price = (Number(reserve['price'].replace(',', '')) - reserve['items'][index]['price']);
      $.ajax({
        url: '/reservations/destroy_item',
        type: 'POST',
        data: {
          id: id,
          price: price
        }
      }).done(function() {
        reserve['price'] = price.toLocaleString();
        reserve['items'].splice(index, 1);
        localStorage.setItem('reserve', JSON.stringify(reserve));
        window.location.href = '/my';
      });
    }
  });
});
